import CookieWarning from './CookieWarningContainer'
export default CookieWarning
